
<template>
  <div id="agUgPage">
    <!-- modals -->
    <ag-user-modal ref="userModal" :user="modalUser" @savedUser="savedUser"></ag-user-modal>

    <b-modal
      v-if="modalUser"
      class="agModal"
      ref="deleteUserModal"
      centered
      no-close-on-esc
      no-close-on-backdrop
      @keyup.enter.native="deleteButton_click">
      <template slot="modal-header">
        <h4 class="agModal-title danger">Delete User</h4>
      </template>
      Are you sure you want to delete user
      <i>{{modalUser.name}}</i>?
      <template slot="modal-footer" slot-scope="{cancel}">
        <b-button class="agModal-buttonLeft" @click="cancel">Cancel</b-button>
        <b-button
          class="agModal-buttonRight"
          variant="danger"
          @click="confirmDeleteUserButton_click"
        >Delete</b-button>
      </template>
    </b-modal>

    <ag-group-modal ref="groupModal" :group="modalGroup" :users="users" @savedGroup="savedGroup"></ag-group-modal>

    <b-modal
      v-if="modalGroup"
      class="agModal"
      ref="deleteGroupModal"
      centered
      no-close-on-esc
      no-close-on-backdrop
      @keyup.enter.native="deleteButton_click"
    >
      <template slot="modal-header">
        <h4 class="agModal-title danger">Delete Group</h4>
      </template>
      Are you sure you want to delete group
      <i>{{modalGroup.name}}</i>?
      <template slot="modal-footer" slot-scope="{cancel}">
        <b-button class="agModal-buttonLeft" @click="cancel">Cancel</b-button>
        <b-button
          class="agModal-buttonRight"
          variant="danger"
          @click="confirmDeleteGroupButton_click"
        >Delete</b-button>
      </template>
    </b-modal>

    <!-- toolbar -->
    <ag-toolbar>
      <template slot="leftContent">
        <b-dropdown 
          class="agDropdown" 
          no-caret
          dropright
          v-b-tooltip.hover
          title="Add user/group">
          <template slot="button-content">
            <fa icon="plus" />
          </template>
          <b-dropdown-item href="#" @click="addButtonItem_click('user')">
            <fa icon="user" />User
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="addButtonItem_click('group')">
            <fa icon="users" />Group
          </b-dropdown-item>
        </b-dropdown>
      </template>
      <template slot="rightContent">
        <b-spinner v-if="isLoading" id="agUgPage-loading"></b-spinner>
      </template>
    </ag-toolbar>

    <!-- users & groups -->
    <b-card id="agUgPage-ugs">
      <b-tabs align="center" card>
        <b-tab title="Users" active>
          <b-table
            :key="'users-' + reloadUsers"
            id="agUgPage-userTable"
            :items="users"
            :fields="userFields"
            borderless
            outlined
            small
            striped
          >
            <template #cell(groups)="data">
              <div>{{getGroupsString(data.item)}}</div>
            </template>
            <template #cell(action)="data">
              <b-dropdown 
                class="agDropdown" 
                no-caret 
                dropleft
                v-b-tooltip.hover
                title="Actions">
                <template slot="button-content">
                  <fa icon="cog" />
                </template>
                <b-dropdown-item href="#" @click="editUserButton_click(data.item)">
                  <fa icon="pen" />Edit
                </b-dropdown-item>
                <b-dropdown-item href="#" class="danger" @click="deleteUserButton_click(data.item)">
                  <fa icon="ban" />Delete
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
        </b-tab>
        <b-tab title="Groups">
          <b-table
            :key="'groups-' + reloadGroups"
            id="agUgPage-groupTable"
            :items="groups"
            :fields="groupFields"
            borderless
            outlined
            small
            striped
          >
            <template #cell(users)="data">
              <div>{{getUsersString(data.item)}}</div>
            </template>
            <template #cell(action)="data">
              <b-dropdown 
                class="agDropdown" 
                no-caret 
                dropleft
                v-b-tooltip.hover
                title="Actions">
                <template slot="button-content">
                  <fa icon="cog" />
                </template>
                <b-dropdown-item href="#" @click="editGroupButton_click(data.item)">
                  <fa icon="pen" />Edit
                </b-dropdown-item>
                <b-dropdown-item
                  href="#"
                  class="danger"
                  @click="deleteGroupButton_click(data.item)"
                >
                  <fa icon="ban" />Delete
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>






<script>
// components
import Toolbar from "comp/ui/Toolbar";
import UserModal from "comp/user/UserModal";
import GroupModal from "comp/user/GroupModal";

// modules
import Server from "src/server";
import Util from "src/util/util";

export default {
  name: "ag-users-groups-page",
  components: {
    "ag-toolbar": Toolbar,
    "ag-user-modal": UserModal,
    "ag-group-modal": GroupModal
  },
  props: {},
  data() {
    return {
      reloadUsers: 0,
      reloadGroups: 0,
      isLoading: false,
      modalUser: null,
      modalGroup: null,
      userFields: [
        { key: "username", label: "Username", sortable: true },
        { key: "name", label: "Name", sortable: true },
        { key: "role", label: "Role", sortable: true },
        { key: "groups", label: "Groups" },
        { key: "action", label: " " }
      ],
      groupFields: [
        { key: "name", label: "Name", sortable: true },
        { key: "description", label: "Description", sortable: true },
        { key: "users", label: "Users" },
        { key: "action", label: " " }
      ]
    };
  },

  computed: {
    users() {
      return this.$store.state.userStore.users;
    },

    groups() {
      return this.$store.state.userStore.groups;
    }
  },

  watch: {},

  created() {},

  mounted() {},

  methods: {
    // UI Events

    addButtonItem_click(type) {
      if (type == "user") {
        this.modalUser = {
          role: "read/write" // default
        };
        this.$refs.userModal.show();
      } else if (type == "group") {
        this.modalGroup = {
          users: []
        };
        this.$refs.groupModal.show();
      }
    },

    editUserButton_click(user) {
      this.modalUser = JSON.parse(JSON.stringify(user));
      this.$refs.userModal.show();
    },

    deleteUserButton_click(user) {
      this.modalUser = JSON.parse(JSON.stringify(user));
      setTimeout(() => {
        this.$refs.deleteUserModal.show();
      }, 250);
    },

    async confirmDeleteUserButton_click() {
      this.isLoading = true;
      this.$refs.deleteUserModal.hide();
      var result = await this.$store.dispatch("userStore/deleteUser", {
        user: this.modalUser
      });
      this.isLoading = false;
      this.reloadUsers++;
    },

    editGroupButton_click(group) {
      this.modalGroup = JSON.parse(JSON.stringify(group));
      this.$refs.groupModal.show();
    },

    deleteGroupButton_click(group) {
      this.modalGroup = JSON.parse(JSON.stringify(group));
      setTimeout(() => {
        this.$refs.deleteGroupModal.show();
      }, 250);
    },

    async confirmDeleteGroupButton_click() {
      this.isLoading = true;
      this.$refs.deleteGroupModal.hide();
      var result = await this.$store.dispatch("userStore/deleteGroup", {
        group: this.modalGroup
      });
      this.isLoading = false;
      this.reloadGroups++;
    },

    // emitted Events

    savedUser() {
      this.reloadUsers++;
    },

    savedGroup() {
      this.reloadGroups++;
    },

    // other

    getUsersString(group) {
      var usersStr = "";
      for (var i = 0; i < group.users.length; i++) {
        var user = group.users[i];
        usersStr += user.username + ", ";
      }
      usersStr = usersStr.substring(0, usersStr.length - 2); // remove last ', '
      return usersStr;
    },

    getGroupsString(user) {
      var groupsStr = "";
      for (var i = 0; i < this.groups.length; i++) {
        var group = this.groups[i];
        var existing = group.users.find((a) => a.username == user.username);
        if (existing) {
          groupsStr += group.name + ", ";
        }
      }
      groupsStr = groupsStr.substring(0, groupsStr.length - 2); // remove last ', '
      return groupsStr;
    }
  }
};
</script>






<style scoped lang="css">
#agUgPage-ugs {
  position: relative;
  height: calc(100vh - 150px);
  top: 65px;
  overflow: auto;
}

#agUgPage-loading {
  position: relative;
  width: 30px;
  height: 30px;
  top: 10px;
  border-left-color: #4A797C;
  border-top-color: #4A797C;
  border-bottom-color: #4A797C;
}

.nav-link {
  color: #4A797C;
}

.nav-link:hover {
  color: #4A797C;
}

#agUgPage-userTable {
  text-align: left;
}

#agUgPage-userTable tr td:nth-child(5) {
  text-align: right;
  width: 30px;
}

#agUgPage-groupTable {
  text-align: left;
}

#agUgPage-groupTable tr td:nth-child(4) {
  text-align: right;
  width: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/UsersGroupsPage.vue